import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { FC, useEffect, useState } from 'react';

type MultipleInputsDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (value: string, value2: string) => void;
  title?: string;
  inputs: [value: string, value2: string];
  defaultValues?: [value: string, value2: string];
  cancelLabel?: string;
  confirmLabel?: string;
};

const MultipleInputsDialog: FC<MultipleInputsDialogProps> = (props) => {
  const { open, onClose, onConfirm, title, inputs, defaultValues, cancelLabel, confirmLabel } = props;
  const [value, setValue] = useState('');
  const [value2, setValue2] = useState('');

  const handleConfirm = () => {
    onConfirm(value, value2);
  };

  useEffect(() => {
    if (defaultValues) {
      setValue(defaultValues[0]);
      setValue2(defaultValues[1]);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} disableRestoreFocus>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box>
          <TextField
            label={inputs[0]}
            size='small'
            autoFocus={open}
            value={value}
            onChange={(event) => setValue(event.currentTarget.value)}
            InputProps={{ autoComplete: 'off' }}
            sx={{ mt: 1 }}
          />
        </Box>
        <Box>
          <TextField
            label={inputs[1]}
            size='small'
            value={value2}
            onChange={(event) => setValue2(event.currentTarget.value)}
            InputProps={{ autoComplete: 'off' }}
            sx={{ mt: 1 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          {cancelLabel ?? 'Cancel'}
        </Button>
        <Button onClick={handleConfirm} color='primary'>
          {confirmLabel ?? 'Ok'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MultipleInputsDialog;
